import PostulateJobs from "../components/dashboard/PostulateJobs";
import { ContainerGapDefault } from "../shared/templates";

const Dashboard = () => {
	return (
		<ContainerGapDefault>
			<PostulateJobs />
		</ContainerGapDefault>
	);
};

export default Dashboard;
